/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { publicBookingRegions } from '../../axios/publicBookingRegions'
import type {
	PublicBookingRegionsError,
	PublicBookingRegionsPathParams,
	PublicBookingRegionsResponse,
} from '../../types/PublicBookingRegions'

export const publicBookingRegionsQueryKey = (tokenString: PublicBookingRegionsPathParams['tokenString']) =>
	[{ url: '/interview-scheduling/booking/:tokenString/regions', params: { tokenString } }] as const

export type PublicBookingRegionsQueryKey = ReturnType<typeof publicBookingRegionsQueryKey>

/** @see backend/nexus/modules/InterviewScheduling/Http/Controllers/PublicBookingController.php PublicBookingController::regions */
export function publicBookingRegionsQueryOptions(
	tokenString: PublicBookingRegionsPathParams['tokenString'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		PublicBookingRegionsResponse,
		AxiosError<PublicBookingRegionsError>,
		PublicBookingRegionsResponse,
		PublicBookingRegionsQueryKey
	>({
		queryKey: publicBookingRegionsQueryKey(tokenString),
		queryFn: ({ signal }) => publicBookingRegions(tokenString, { signal, ...config }).then(res => res.data),
		enabled: !!tokenString,
	})
}

/** @see backend/nexus/modules/InterviewScheduling/Http/Controllers/PublicBookingController.php PublicBookingController::regions */
export function usePublicBookingRegions<TSelectData = PublicBookingRegionsResponse>(
	tokenString: PublicBookingRegionsPathParams['tokenString'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					PublicBookingRegionsResponse,
					AxiosError<PublicBookingRegionsError>,
					TSelectData,
					PublicBookingRegionsQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<PublicBookingRegionsError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...publicBookingRegionsQueryOptions(tokenString),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/InterviewScheduling/Http/Controllers/PublicBookingController.php PublicBookingController::regions */
export function usePublicBookingRegionsSuspense<TSelectData = PublicBookingRegionsResponse>(
	tokenString: PublicBookingRegionsPathParams['tokenString'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					PublicBookingRegionsResponse,
					AxiosError<PublicBookingRegionsError>,
					TSelectData,
					PublicBookingRegionsQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<PublicBookingRegionsError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...publicBookingRegionsQueryOptions(tokenString),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
